import { CanAccess } from 'react-admin'
import { PartnersSelect } from './concepts/Admin/views/PartnersSelect'
import PaymentInfo from './concepts/Account/views/PaymentInfo'
import GeneralInfo from './concepts/Account/views/GeneralInfo'
import Deductions from './concepts/Earnings/views/Deductions'
import PaymentStatus from './concepts/Earnings/views/PaymentStatus'
import { Insights } from './concepts/StackMedia/views/Insights'
import { Resources } from './concepts/Resources/views/Resources'
import { ArticlesCalendar } from './concepts/Calendar/views/ArticlesCalendar'
import { MenuFolder, MenuLink } from './layout/Menu'
import { Orders } from './concepts/Orders/views/Orders'
export type MenuItems = (MenuLink | MenuFolder)[]

export const routesConfig = [
  {
    path: '/roles',
    element: (
      <CanAccess resource="roles" action="read">
        <PartnersSelect />
      </CanAccess>
    )
  },
  { path: '/account/general-info', element: <GeneralInfo /> },
  { path: '/account/payment-info', element: <PaymentInfo /> },
  {
    path: '/earnings/deductions',
    element: (
      <CanAccess resource="/earnings/deductions" action="read">
        <Deductions />
      </CanAccess>
    )
  },
  { path: '/earnings/payment-status', element: <PaymentStatus /> },
  {
    path: '/calendar',
    element: (
      <CanAccess resource="calendar" action="read">
        <ArticlesCalendar />
      </CanAccess>
    )
  },
  { path: '/stack-media', element: <Insights /> },
  {
    path: '/resources',
    element: (
      <CanAccess resource="resources" action="read">
        <Resources />
      </CanAccess>
    )
  },
  {
    path: '/orders',
    element: (
      <CanAccess resource="orders" action="read">
        <Orders />
      </CanAccess>
    )
  }
]
